import { HandleOptimizeClickParams } from '../../types/optimizerTable.js';

export const handleOptimizeClick = async ({
  optimizeData,
  setIsOptimizeLoading,
  setOptimizeData,
  dispatch,
  setOpenAlternatives,
  optimizeCosts,
  setStatusAnalyzeFile,
  openAlternatives,
}: HandleOptimizeClickParams) => {
  try {
    setIsOptimizeLoading(true);
    const dataForRequest = optimizeData.map(row => ({
      ...row,
      optimizationOptions: Array.isArray(row.optimizationOptions)
        ? row.optimizationOptions.filter(option => option.enabled)
        : [],
    }))
      .filter(row =>
        row.optimizationOptions.length > 0 &&
        !row.optimizationOptions.some(option => option.optCostsResults),
      );

    const recordsData = await optimizeCosts(dataForRequest, optimizeData);
    if (recordsData) {
      setOptimizeData(recordsData);
      dispatch(setStatusAnalyzeFile({ status: 'success', records: recordsData }));

      const newOpenAlternatives = { ...openAlternatives };
      recordsData.forEach(record => {
        record.optimizationOptions.forEach(option => {
          if (option.optCostsResults) {
            newOpenAlternatives[option.id] = true;
          }
        });
      });
      setOpenAlternatives(newOpenAlternatives);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  } catch (error) {
    console.error('Error during optimization:', error);
  } finally {
    setIsOptimizeLoading(false);
  }
};
